module.exports = __webpack_public_path__ + "img/lounge-fm.465ddf41.png";